module.exports = __webpack_public_path__ + "media/images/regions/causal_graphs/middle_east_and_north_africa-52e7123351581b9a79c7a1a287945226.svg";